export const SET_STATE_GLOBAL = 'SET_STATE_GLOBAL';
export const setStateGlobal = (state, value) => ({
  type: SET_STATE_GLOBAL,
  state,
  value,
});
